import { useEffect } from 'react'
import { useState } from 'react'
import { Option, ModalClose, Select, Modal, ModalDialog, Button } from '@mui/joy'
import { getUniqueRoots } from '../../utils/note-key-helper';
import './customTuning.scss'

const CustomTuning = ({ modalOpen, setModalOpen, tuning, setTuning }) => {
    const stringOptions = [4, 5, 6, 7, 8];
    const [numberOfStrings, setNumberOfStrings] = useState(6);
    const [tempTuning, setTempTuning] = useState([]);

    useEffect(() => {
        if (modalOpen) {
            setNumberOfStrings(tuning.length);
            setTempTuning([...tuning]);
        }
    }, [modalOpen, tuning])

    useEffect(() => {
        if (tempTuning.length === 0) return;

        const uniqueRoots = getUniqueRoots();
        const newTuning = [...tempTuning];

        if (numberOfStrings > newTuning.length) {
            while (newTuning.length < numberOfStrings) {
                newTuning.push(uniqueRoots[newTuning.length % uniqueRoots.length]);
            }
        } else if (numberOfStrings < newTuning.length) {
            newTuning.splice(numberOfStrings);
        }

        setTempTuning(newTuning);
    }, [numberOfStrings])

    const handleStringChange = (__event, newValue) => {
        setNumberOfStrings(newValue);
    }

    const handleNoteSelect = (index, newValue) => {
        const newTuning = [...tempTuning];
        newTuning[index] = newValue;
        setTempTuning(newTuning);
    }

    const handleApplyTuning = () => {
        setTuning(tempTuning);
        setModalOpen(false);
    }

    return (
        <div className='custom-tuning'>
            <Modal open={modalOpen} onClose={() => setModalOpen(false)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ModalDialog>
                    <ModalClose variant="plain" />
                    <h2>Custom Tuning</h2>
                    <Select value={numberOfStrings} onChange={handleStringChange} variant='soft' color='primary'>
                        {stringOptions.map((option) => (
                            <Option key={option} value={option}>{option} Strings</Option>
                        ))}
                    </Select>
                    <div className='custom-tuning__strings'>
                        {Array.from({ length: numberOfStrings }, (_, index) => (
                            <div key={index} className='custom-tuning__string-note'>
                                <Select
                                    className='custom-tuning__string-select'
                                    value={tempTuning[index] || getUniqueRoots()[0]}
                                    onChange={(__event, value) => handleNoteSelect(index, value)}
                                    variant='soft'
                                    color='primary'
                                >
                                    {getUniqueRoots().map((root) => (
                                        <Option key={root} value={root}>{root}</Option>
                                    ))}
                                </Select>
                                <div className='string-size' style={{borderWidth: (index + 1) + 'px'}}></div>
                            </div>
                        ))}
                    </div>
                    <Button variant='solid' color='primary' onClick={() => handleApplyTuning()}>Apply Tuning</Button>
                    <Button variant='outlined' color='neutral' onClick={() => setModalOpen(false)}>Cancel</Button>
                </ModalDialog>
            </Modal>
        </div>
    )
}

export default CustomTuning